<template>
    <div id="alternative-button">
        <h2>{{ Text }}</h2>
    </div>
</template>

<script>
export default {
    props:['Text'],
    computed:{
        CostCalculated(){
            return this.$store.getters['orders/costCalculated']
        }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
@media only screen and (max-width:420px){
    #alternative-button{
        border-radius: 16px;
        width: 40vw;
        margin-left:30vw;
        margin-top:10px;
        margin-bottom:30px;
        height: 47px;
        background: var(--Brand-color-3, #8D8D8D);
    }
    #alternative-button h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 47px;
    }
}
@media only screen and (min-width:480px) and (max-width:960px){
    #alternative-button{
        border-radius: 16px;
        width: 30vw;
        margin-left:35vw;
        height: 57px;
        background: var(--Brand-color-3, #8D8D8D);
        margin-top:-5px;
        margin-bottom:6vh;
    }
    #alternative-button h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 57px;
    }
}
@media only screen and (min-width:961px){
    #alternative-button{
        border-radius: 16px;
        width: 20vw;
        margin-left:40vw;
        height: 57px;
        background: var(--Brand-color-3, #8D8D8D);
        margin-top:-10px;
        cursor: pointer;
        margin-bottom:4vh;
    }
    #alternative-button h2{
        color: #FFF;
text-align: center;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 400;
line-height: 57px;
    }
}
</style>